var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGlassmorphic = function SvgGlassmorphic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 440,
    height: 956
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "paint0_angular_12_508_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.057 473.283c-138.53 63.489-235.615-43.67-255.278-93.082-34.484-156.981 149.414-121.927 202.038-160.96 65.779-48.791 115.457-182.184 221.695-164.99C392.75 71.447 446.346 189.834 448.498 328.067c2.152 138.234 36.141 105.255 198.863 268.103 130.179 130.277 41.679 235.186-45.562 239.652-76.336 3.907-185.789-30.208-219.632-177.785-42.302-184.471-97.72-261.009-264.11-184.753Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_12_508",
    x: -331.496,
    y: -137.268,
    width: 1234.7,
    height: 1163.38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 95,
    result: "effect1_foregroundBlur_12_508"
  })))));
};
export default SvgGlassmorphic;